/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Alert, AlertTitle, Box, Divider, Grid, Typography, useTheme } from '@mui/material';

import { CardPiezometro, ToolsDetails } from '../../../../../components/custom';
import { LayoutBase } from '../../../../../layouts';
import { DamsServices } from '../../../../../services/api/dams/DamServices';
import { CustomAlert, VSelecInstruments } from '../../../../../components/shared';
import { IReading, ReadingServices } from '../../../../../services/api/reading/ReadingServices';
import { CardBase, CardInclinometro, CardIndicador, CardMarco, CardPluviometro, CardRe, CardRegua, CardVazao } from '../../../../../components/custom/registration-reading';

export const IntrumentReading = () => {

    const url = useParams();

    const theme = useTheme();
    const urlNav = `/information_dam/${url.id}/instrument/new`;

    const [instruments, setInstruments] = useState<any>([]);
    const [typeSelectInstrument, setTypeInstrument] = useState<string>('');
    const [filterInstrument, setFilterInstrument] = useState<any>();
    const [dataInstrument, setDataInstrument] = useState<IReading[]>();
    const [alertInfo, setAlertInfo] = useState<{ open: boolean; message: string; severity: 'success' | 'error' | 'warning' | 'info' }>({
        open: false,
        message: '',
        severity: 'success'
    });

    useEffect(() => {
        fecthData();
    }, [url]);

    console.log('url:', url);


    const fecthData = () => {
        if (url.id !== undefined) {
            DamsServices.getById(url.id)
                .then((data) => {
                    if (data instanceof Error) {
                        console.log(data.message);
                    } else {
                        setInstruments(data.instrumentos);
                    }
                });
        }

        if (url.instrumento != undefined) {
            setTypeInstrument(url.instrumento);
        }
    };

    function handleTipo(novoTipo: string) {
        setTypeInstrument(novoTipo);
    }

    useEffect(() => {
        const filterInstruments = typeSelectInstrument ?
            instruments.filter((instrumento: any) => instrumento.tipo_instrumento === typeSelectInstrument)
            : [];
        setFilterInstrument(filterInstruments);
    }, [typeSelectInstrument, instruments]);

    const handleDataChange = (newData: IReading[]) => {
        setDataInstrument(newData);

    };

    const formatDateTime = (dateTimeStr: string): string => {
        const date = new Date(dateTimeStr);

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = String(date.getFullYear()).slice(-2);

        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        return `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;
    };

    const showAlert = (message: string, severity: 'success' | 'error' | 'warning' | 'info') => {
        setAlertInfo({ open: false, message: '', severity: 'info' });
        setTimeout(() => {
            setAlertInfo({ open: true, message, severity });
        }, 100);
    };

    async function handleSave() {
        if (dataInstrument && dataInstrument.length > 0) {
            const newErrors = Array(dataInstrument.length).fill(false);
            for (const index in dataInstrument) {
                if (!dataInstrument[index].sem_leitura) {
                    const uuid = dataInstrument[index].uuid as string;
                    const dataLeituraStr = dataInstrument[index].data_leitura?.toString();
                    if (dataLeituraStr != undefined) {
                        dataInstrument[index].data_leitura = formatDateTime(dataLeituraStr);
                    }
                    dataInstrument[index].tipo_instrumento = typeSelectInstrument;
                    const data = dataInstrument[index];
                    delete data.uuid;
                    delete data.sem_leitura;
    
                    if (uuid) {
                        try {
                            const result = await ReadingServices.create(uuid, data);
    
                            if (result && result.data) { 
                                showAlert('Leitura Salva!', 'success');
                                setTimeout(() => setFilterInstrument(''), 2000);
                            } else {
                                showAlert('Leitura salva, mas sem dados de confirmação.', 'warning');
                            }
                        } catch (error: any) {
                            console.error('Erro ao salvar leitura (API ou rede):', error);
                            let errorMessage = 'Erro ao Salvar leitura.';
                            if (error.message) {
                                errorMessage = `Erro ao Salvar leitura: ${error.message}`;
                            }
                            showAlert(errorMessage, 'error');
                            newErrors[index] = true; 
                        }
                    } else {
                        newErrors[index] = true;
                        showAlert('UUID do instrumento não encontrado.', 'error'); 
                    }
                }
            }
            if (newErrors.some(error => error)) {
                console.warn('Algumas leituras falharam ao serem salvas.');
            } else {
                console.log('Todas as leituras processadas sem erros aparentes.');
            }
        }
    }

    return (
        <LayoutBase
            title='Nova leitura'
            tollBar={
                <ToolsDetails
                    onClickSave={handleSave}
                    showDeletButton={false}
                    showNewButton={false}
                />}
        >
            <Box width={'100%'} display={'flex'} flexDirection={'column'}>
                <Grid container direction="column" gap={2}>
                    <Grid item>
                        <Typography variant="h4" color={theme.palette.primary.main}>
                            Cadastro de leitura
                        </Typography>
                        <Divider />
                    </Grid>

                    <Grid container direction="row" alignItems="center" gap={1} justifyContent="space-around">
                        <Grid container padding={1}>
                            <Grid item xs={12}>
                                <Grid container justifyContent="center" mb={2}>
                                    <Alert
                                        severity="info"
                                        sx={{
                                            width: '100%',
                                            maxWidth: '600px',
                                            margin: '0 auto',
                                        }}
                                    >
                                        <AlertTitle color="primary">Atenção!</AlertTitle>
                                        Por favor atente-se ao preenchimento correto dos campos,
                                        o único não obrigatório é o de comentários. <br/>
                                        Os níveis de leitura são Normal, Atenção, Alerta e Emergência.
                                    </Alert>
                                </Grid>

                                <Grid item xs={12} sm={6} md={4}>
                                    <Typography>Tipo de instrumentos</Typography>
                                    <VSelecInstruments
                                        onTipoChange={(novoTipo) => handleTipo(novoTipo)}
                                        activeLabel={false}
                                        tipoInicial={url.instrumento ?? undefined}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Box>
                    {typeSelectInstrument === 'piezometro' && (
                        <Box width={'100%'} marginTop={2}>
                            <CardPiezometro instrumentos={filterInstrument} urlNav={urlNav} onDataChange={handleDataChange} url_selecionada={url.uuid} />
                        </Box>
                    )}
                    {typeSelectInstrument === 'indicador' && (
                        <Box width={'100%'} marginTop={2}>
                            <CardIndicador instrumentos={filterInstrument} urlNav={urlNav} onDataChange={handleDataChange} url_selecionada={url.uuid} />
                        </Box>
                    )}
                    {typeSelectInstrument === 'vazao' && (
                        <Box width={'100%'} marginTop={2}>
                            <CardVazao instrumentos={filterInstrument} urlNav={urlNav} onDataChange={handleDataChange} url_selecionada={url.uuid} />
                        </Box>
                    )}
                    {typeSelectInstrument === 'regua' && (
                        <Box width={'100%'} marginTop={2}>
                            <CardRegua instrumentos={filterInstrument} urlNav={urlNav} onDataChange={handleDataChange} url_selecionada={url.uuid} />
                        </Box>
                    )}
                    {typeSelectInstrument === 're' && (
                        <Box width={'100%'} marginTop={2}>
                            <CardRe instrumentos={filterInstrument} urlNav={urlNav} onDataChange={handleDataChange} url_selecionada={url.uuid} />
                        </Box>
                    )}
                    {typeSelectInstrument === 'base' && (
                        <Box width={'100%'} marginTop={2}>
                            <CardBase instrumentos={filterInstrument} urlNav={urlNav} onDataChange={handleDataChange} url_selecionada={url.uuid} />
                        </Box>
                    )}
                    {typeSelectInstrument === 'inclinometro' && (
                        <Box width={'100%'} marginTop={2}>
                            <CardInclinometro instrumentos={filterInstrument} urlNav={urlNav} onDataChange={handleDataChange} url_selecionada={url.uuid} />
                        </Box>
                    )}
                    {typeSelectInstrument === 'marco' && (
                        <Box width={'100%'} marginTop={2}>
                            <CardMarco instrumentos={filterInstrument} urlNav={urlNav} onDataChange={handleDataChange} url_selecionada={url.uuid} />
                        </Box>
                    )}
                    {typeSelectInstrument === 'pluviometro' && (
                        <Box width={'100%'} marginTop={2}>
                            <CardPluviometro instrumentos={filterInstrument} urlNav={urlNav} onDataChange={handleDataChange} />
                        </Box>
                    )}
                </Box>
                {alertInfo.open &&
                    <CustomAlert
                        message={alertInfo.message}
                        severity={alertInfo.severity}
                    />
                }
            </Box>
        </LayoutBase>
    );
};
